export default function AgeBreakdown({ byAge = [], known = 0, total = 0 }) {
  const max = Math.max(1, ...byAge.map((a) => a.count));
  const groups = [
    { label: "6–9", from: 6, to: 9 }, { label: "10–13", from: 10, to: 13 }, { label: "14–17", from: 14, to: 17 },
  ].map((g) => ({ ...g, count: byAge.filter((a) => a.age >= g.from && a.age <= g.to).reduce((s, a) => s + a.count, 0) }));

  return (
    <div className="panel" data-testid="age-breakdown-panel">
      <div className="map-head"><h3 style={{ margin: 0 }}>Pledges by Age</h3></div>
      <div className="sub-note"><b data-testid="ages-known">{known}</b> of {total} pledges shared an age</div>
      <div className="age-groups">
        {groups.map((g) => (
          <div className="age-group" key={g.label} data-testid={`age-group-${g.label}`}><span className="num">{g.count}</span><span className="lbl">Ages {g.label}</span></div>
        ))}
      </div>
      <div className="age-chart" data-testid="age-chart">
        {byAge.map((a) => (
          <div className="age-col" key={a.age} title={`${a.count} pledge${a.count === 1 ? "" : "s"} at age ${a.age}`} data-testid={`age-col-${a.age}`}>
            <span className="age-count">{a.count || ""}</span>
            <span className="age-bar" style={{ height: `${Math.max(a.count ? 8 : 2, (a.count / max) * 100)}%` }} />
            <span className="age-lbl">{a.age}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
